<mat-card class="card" appDragDropFile (fileDropped)="fileDrop($event)">
    <mat-card-header>
        <mat-card-title fxLayout="row" fxLayoutAlign="space-between center">
            <div>
                Versões de Atualizador do Agente
            </div>
<!--            <div>-->
<!--                <button type="button" mat-raised-button (click)="test()">Test</button>-->
<!--            </div>-->
            <div style="height: 36px;">
                <input (change)="onFileChange($event)" name="file"
                       id="serverAgentUpdaterToUpload" accept=".exe" type="file" style="display:none;">
                <button type="button" mat-raised-button color="accent" onclick="document.getElementById('serverAgentUpdaterToUpload').click()">
                    <mat-icon>cloud_upload</mat-icon>
                </button>
            </div>
        </mat-card-title>
    </mat-card-header>
    <mat-card-content fxLayout="column" fxLayoutAlign="space-between stretch">
        <div fxLayout="row" fxLayoutAlign="space-between center"
             *ngFor="let serverAgentUpdaterFile of serverPluginService.serverAgentUpdaterFiles; let i = index"
             class="row-item" [ngClass]="{'mt-8': i > 0, 'even': i % 2 === 0, 'odd': i % 2 != 0}">
            <div>
                {{serverAgentUpdaterFile.version}}
            </div>
            <div>
                <button type="button" mat-mini-fab color="accent" (click)="onDownload(serverAgentUpdaterFile)">
                    <mat-icon>
                        cloud_download
                    </mat-icon>
                </button>
                <button type="button" class="ml-10" mat-mini-fab color="warn" (click)="onDelete(serverAgentUpdaterFile)">
                    <mat-icon>
                        delete
                    </mat-icon>
                </button>
                <!--                <button type="button" mat-raised-button color="accent" class="ml-8" (click)="onEdit(serverAgentFile)">-->
                <!--                    Editar-->
                <!--                </button>-->
            </div>
        </div>
    </mat-card-content>
</mat-card>